import { envConfig } from '../../envConfig'

const webUrlBase = envConfig.url.API_URL

export const urlDetailProduct = `${webUrlBase}api/mobile/products`
export const urlAddProduct = `${webUrlBase}api/mobile/table_orders/add_item`
export const urlEditProduct = `${webUrlBase}api/mobile/table_orders/edit_item`
